import { Card, CardContent, Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import classnames from "classnames";
import no_resource from "../../assets/images/no_resource.svg";
import no_compiled_sql from "../../assets/images/no_compiled_sql.svg";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { getIntegrationEnvironments } from "../../helpers/apis";
import { RelativeComponentLoader } from "../../components/loader";
import type { IntegrationEnvironment } from "./types";

const GET_INTEGRATION_ENVIRONMENTS = "GET-INTEGRATION-ENVIRONMENTS";

const NoDbtModels = () => {
  return (
    <div className={styles.no_dbt_models}>
      <Card className={styles.card}>
        <CardContent className="al-pt-4">
          <Stack justify="center">
            <Stack
              direction="column"
              align="center"
              className={classnames("p-4", styles.container)}
            >
              <img src={no_resource} alt="No Datasets" className={styles.img} />
              <h2 className="mt-4 mb-4 text-black">No dbt Models</h2>
              <p className="text-muted text-center">
                {/* TODO: Update this message */}
                Please integrate your dbt project to view models
              </p>
              <Link to="/settings/integrations">
                <Button>Add Integration</Button>
              </Link>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
};

interface NoCompiledSqlProps {
  modelName: string;
  integrationId?: number;
  integrationEnvironmentId?: number;
}

const NoCompiledSql = ({
  modelName,
  integrationId,
  integrationEnvironmentId,
}: NoCompiledSqlProps) => {
  const [integrationEnvironment, setIntegrationEnvironment] =
    useState<IntegrationEnvironment | null>(null);

  const { data, isLoading } = useQuery({
    queryKey: [GET_INTEGRATION_ENVIRONMENTS],
    queryFn: () => getIntegrationEnvironments(String(integrationId)),
  });

  // Handle successful data fetch (replaces onSuccess callback removed in TanStack Query v5)
  useEffect(() => {
    if (data) {
      setIntegrationEnvironment(
        data.find(
          integrationEnvironment => integrationEnvironment.id === integrationEnvironmentId
        ) ?? null
      );
    }
  }, [data, integrationEnvironmentId]);

  if (isLoading) {
    return <RelativeComponentLoader componentHeight={50} />;
  }

  return (
    <div className={styles.no_dbt_models}>
      <div className={styles.card}>
        <Stack justify="center">
          <Stack direction="column" align="center" className={classnames("p-4", styles.container)}>
            <img src={no_compiled_sql} alt="No Compiled SQL" className={styles.no_sql} />
            <p className="text-center">
              The model <span className="text-muted">{modelName}</span> did not have the compiled
              sql in the manifest. Please re upload the manifest and catalog after running{" "}
              <span className="text-muted">(dbt compile)</span>
            </p>
            <Link
              to={`/settings/integrations/${integrationId}/${integrationEnvironment?.environment_type}`}
            >
              <Button>Upload Manifest</Button>
            </Link>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};

const NoCompiledSqlTest = (_props: NoCompiledSqlProps) => {
  return (
    <div className={styles.no_dbt_models}>
      <div className={styles.card}>
        <Stack justify="center">
          <Stack direction="column" align="center" className={classnames("p-4", styles.container)}>
            <img src={no_compiled_sql} alt="No Compiled SQL" className={styles.no_sql} />
            <p className="text-center">The test does not have any sql to visualize.</p>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};

export { NoDbtModels, NoCompiledSql, NoCompiledSqlTest };
